/**
 * Created by akirilyuk on 9/27/16.
 */
define(function (require) {
    "use strict";
    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var BaseCollection = require("collections/BaseCollection");
    var CONST = require("const");
    var CommentModel = {};

    var KEYS = {
        ID : "id",
        CREATED_BY_EMAIL : "createdByEmail",
        CREATED_BY_NAME : "createdByName",
        CREATED_DATE : "createdDate",
        MESSAGE : "message",
        PARENT_ID: "parentId",
        CREATED_DATE_CONVERTED: "createdDateConverted"
    };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        CommentModel =  BaseModel.extend({
            initialize: function(){
                this._initDate();
            },

            _initDate: function(){
                if(this.getId()){
                    var createdDate = this.getCreatedDate();
                    if(createdDate){
                        this.setCreatedDate(new Date(Date.UTC(createdDate.year,createdDate.month,
                            createdDate.dayOfMonth,createdDate.hourOfDay,createdDate.minute,createdDate.second)));
                        this.setCreatedDateConverted(this._convertDate(this.getCreatedDate()));
                    }
                }
            },
            setCreatedByEmail: function(email){
                if(email&&_.isString(email)){
                    this.set(KEYS.CREATED_BY_EMAIL,email);
                }
            },

            setCreatedByName: function(name){
                if(name&&_.isString(name)){
                    this.set(KEYS.CREATED_BY_NAME,name);
                }
            },

            setParentId: function(value){
                if(value&&_.isString(value)){
                    this.set(KEYS.PARENT_ID,value);
                }
            },

            getParentId: function(){
                return this.get(KEYS.PARENT_ID);
            },

            getId: function(){
                return this.get(KEYS.ID);
            },

            getCreatedDate: function(){
                return this.get(KEYS.CREATED_DATE);
            },

            setCreatedDate: function(date){
                if(date&&_.isDate(date)){
                    this.set(KEYS.CREATED_DATE, date);
                }
            },

            setCreatedDateConverted: function(converted){
                if(converted&&_.isString(converted)){
                    this.set(KEYS.CREATED_DATE_CONVERTED,converted);
                }
            },

            _convertDate: function(dateObj){
                function pad(n) {return n < 10 ? "0"+n : n;}
                var dateString = "";
                if (dateObj) {
                    if(LE.localeResolver.getLocale()===CONST.LANGUAGE["en-US"]){
                        dateString = pad(dateObj.getMonth()+1)+"/"+pad(dateObj.getDate())+"/"+dateObj.getFullYear();
                    }else{
                        dateString = pad(dateObj.getDate())+"/"+pad(dateObj.getMonth()+1)+"/"+dateObj.getFullYear();
                    }
                    dateString += " " + pad(dateObj.getHours()) + ":" + pad(dateObj.getMinutes()) + ":" + pad(dateObj.getSeconds());
                }
                return dateString;
            }
        });

    });
    CommentModel.KEYS = KEYS;
    return CommentModel;
});
